import { render, staticRenderFns } from "./NuxtLinkExt.vue?vue&type=template&id=b97f098a"
import script from "./NuxtLinkExt.vue?vue&type=script&lang=js"
export * from "./NuxtLinkExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports